<template>
    <div class="multiColor-card text-start" :style="[{'--elements-quantity': elementsQuantity}, {'--border-color': borderColor}]">
        <div class="common-right-border d-flex flex-column align-items-center justify-content-center gap-1 p-2">
            <slot name="left">
            </slot>
        </div>
        <div v-if="elementsQuantity == 3" class="common-right-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
            <slot name="middle">
            </slot>
        </div>
        <div class="common-right-border exception d-flex align-items-center justify-content-center gap-1 p-2">
            <slot name="right">
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    props: {
        elementsQuantity: {
            type: Number,
            default: 3,
        },
        borderColor: {
            type: String,
            default: "#1e5eff80",
        }
    },
}
</script>
<style scoped>
.multiColor-card{
    display: grid;
    grid-template-columns: repeat(var(--elements-quantity), 1fr);
    grid-template-rows: 1fr;
    width: 100%;
    padding: 0.7em;
    background-color: inherit;
    border-radius: 10px;
    border: 3px solid;
    border-color: var(--border-color);
}
.common-right-border:not(.exception){
    border-right: 3px solid transparent;
    padding: 0.5em;
    border-color: var(--border-color);
}
.green-border{
    border-color: #1fd28880;
}
.blue-border{
    border-color: #1e5eff80;
}
.orange-border{
    border-color: #ffcb1080;
}
.multiColor-card .extra-large-text{
    font-size: 15px;
    line-height: 18px;
}
</style>